import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'UserSearchPipe', pure: false })
export class UserSearchPipe implements PipeTransform {
  transform(value, args?): Array<any> {
    const searchText = new RegExp(args, 'ig');
    if (value) {
      return value.filter(employee => {
        if (employee.firstName) {
          return employee.firstName.search(searchText) !== -1;
        }
        else {
          return employee.lastName.search(searchText) !== -1;
        }
      });
    }
    return [];
  }
}
